export default "__VITE_ASSET__048a79a4__"